import { useState, useEffect } from "react";
import { LoadingEnum } from "../../../types/utility/async.js";
const cachedScriptStatuses = {};
function getScriptNode(src) {
  const node = document.querySelector(`script[src="${src}"][data-perxis-auto-script="true"]`);
  const status = node == null ? void 0 : node.getAttribute("data-status");
  return {
    node,
    status
  };
}
function useScript(src, options) {
  const [status, setStatus] = useState(() => {
    if (!src || (options == null ? void 0 : options.shouldPreventLoad)) {
      return LoadingEnum.Idle;
    }
    if (typeof window === "undefined") {
      return LoadingEnum.Pending;
    }
    return cachedScriptStatuses[src] ?? LoadingEnum.Pending;
  });
  useEffect(() => {
    if (!src || (options == null ? void 0 : options.shouldPreventLoad)) {
      return;
    }
    const cachedScriptStatus = cachedScriptStatuses[src];
    if (cachedScriptStatus === LoadingEnum.Succeeded || cachedScriptStatus === LoadingEnum.Failed) {
      setStatus(cachedScriptStatus);
      return;
    }
    const script = getScriptNode(src);
    let scriptNode = script.node;
    if (!scriptNode) {
      scriptNode = document.createElement("script");
      scriptNode.src = src;
      scriptNode.async = true;
      scriptNode.setAttribute("data-status", "loading");
      scriptNode.setAttribute("data-perxis-auto-script", "true");
      if (options == null ? void 0 : options.type) {
        scriptNode.type = options.type;
      }
      if (options == null ? void 0 : options.dataAttributes) {
        Object.entries(options.dataAttributes).forEach(([key, value]) => {
          scriptNode == null ? void 0 : scriptNode.setAttribute(key, value);
        });
      }
      if ((options == null ? void 0 : options.onload) && typeof (options == null ? void 0 : options.onload) === "string") {
        scriptNode.onload = window[options.onload];
      }
      document.body.appendChild(scriptNode);
      const setAttributeFromEvent = (event) => {
        const scriptStatus = event.type === "load" ? LoadingEnum.Succeeded : LoadingEnum.Failed;
        scriptNode == null ? void 0 : scriptNode.setAttribute("data-status", scriptStatus);
      };
      scriptNode.addEventListener("load", setAttributeFromEvent);
      scriptNode.addEventListener("error", setAttributeFromEvent);
    } else {
      setStatus(script.status ?? cachedScriptStatus ?? LoadingEnum.Pending);
    }
    const setStateFromEvent = (event) => {
      const newStatus = event.type === "load" ? LoadingEnum.Succeeded : LoadingEnum.Failed;
      setStatus(newStatus);
      cachedScriptStatuses[src] = newStatus;
    };
    scriptNode.addEventListener("load", setStateFromEvent);
    scriptNode.addEventListener("error", setStateFromEvent);
    return () => {
      if (scriptNode) {
        scriptNode.removeEventListener("load", setStateFromEvent);
        scriptNode.removeEventListener("error", setStateFromEvent);
      }
      if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
        scriptNode.remove();
      }
    };
  }, [src, options]);
  return status;
}
export {
  useScript
};
